import clsx from 'clsx';
import React from 'react';

import styles from './Hamburger.module.scss';

type HamburgerProps = {
    className?: string;
    onClick?: () => void;
    isActive: boolean;
};

export const Hamburger: React.FC<HamburgerProps> = ({ className, isActive, onClick }) => (
    <div
        className={clsx(styles.root, className, { [styles['is-active']]: isActive })}
        onClick={onClick}
        aria-label={isActive ? 'Close navigation menu' : 'Open navigation menu'}
        aria-expanded={isActive}
        aria-controls="mobile-menu"
    >
        <div></div>
        <div></div>
        <div></div>
    </div>
);
